/* eslint no-template-curly-in-string: 0 */

import { PAYMENT_NETWORKS, FLOW_TYPES, PAYMENT_STATUSES } from "../../utils/enums";
import physicalDebitCardLogo from "../../assets/images/mastercard-logo.png";
import prepaidMastercardFees from "../../assets/images/Disburse_Phy_MC wATM Short Form_STD-MPC.pdf";

const disclosureOfFeesFaq = {
  answer: `<a href="${prepaidMastercardFees}" target="_blank">Disclosure of Fees</a>`,
  question: "Mastercard Physical Debit/ATM Card Disclosure of Fees"
};

export const physicalDebitCard = {
  id: PAYMENT_NETWORKS.PHYSICALDEBITATMCARD_BLACKHAWK_MASTERCARD,
  displayName: "Mastercard Physical Debit/ATM Card",
  paywall: {
    tile: {
      displayName: ["Mastercard Physical Debit/ATM Card"],
      tagline: ["Delivers in 10-14 business days"],
      description: [
        // "Immediate cash, with ATM access.",
        "For use online, in-store, or at an ATM.",
      ],
      // btnLabel: "Go",
      logo: physicalDebitCardLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.COLLECT_ADDRESS,
    title: "Mastercard Physical Debit/ATM Card",
    description: [
      "Please confirm your mailing address. Allow 10-14 business days for delivery. Fees may apply for cash withdrawals."
    ],
    showStartOver: true,
  },
  acceptPayment: {
    title: ["Confirm Payment"],
    autoAcceptDurationInSeconds: 10,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.COLLECT_ADDRESS,
    description: "Please confirm your mailing address is correct as displayed below. Once submitted, the delivery address for your physical debit/ATM card cannot be changed.",
    secondaryText: [
      {
        string: "We encourage you to use your card once every 12 months to avoid inactivity fees. After one year of inactivity, monthly default fees of $5.95 occur.",
        props: {
          style: {
            fontSize: "0.8rem",
            lineHeight: "1.2",
            padding: "0 1em",
            display: "block",
            textAlign: "center",
            marginBottom: "2em",
          }
        }
      }
    ],
    btnLabel: 'SUBMIT',
    imgSrc: physicalDebitCardLogo,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        disclosureOfFeesFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        disclosureOfFeesFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        disclosureOfFeesFaq
      ],
    }
  },
  networkSelectionAccepted: {
    imgSrc: physicalDebitCardLogo,
    title: ["Success!"],
    description: [
      "Please check your email ",
      {
        string: "${payment.recipientNotificationPreference}",
        transformations: [
          {
            type: 'formatEmailAddressOrMobilePhoneNumber',
          }
        ],
        props: {
          className: 'payment-recipientEmail'
        }
      },
      " for details regarding your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork',
        }
      },
      " for ",
      {
        string: "${payment.acceptedAmount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.acceptedCurrency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      ". Your card should arrive within 10-14 business days and will include details for your use."
    ],
    secondaryText: [
      "Upon receipt, please treat this physical debit/ATM card like cash and care for it accordingly to avoid loss or theft."
    ]
  },
  paymentComplete: {
    title: "Payment Complete",
    initial: {
      description: [
        "Success! A physical debit/ATM card for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " will be mailed to you in approximately 10-14 business days."
      ],
      secondaryText: [
        "A confirmation will be ",
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatPaymentNetworkRecipientType',
            }
          ],
        },
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatEmailAddressOrMobilePhoneNumber',
            },
          ],
          props: {
            className: 'payment-recipientEmail'
          }
        },
        "."
      ]
    },
    revisit: {
      description: [
        "Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: "payment-recipientEmail"
          }
        },
        " for details regarding your payment for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount"
          }
        },
        ". Expect your physical debit/ATM card to be received at your address on file in 10-14 business days.",
      ],
      secondaryText: " "
    },
    imgSrc: physicalDebitCardLogo
  },
  onHold: {
    imgSrc: physicalDebitCardLogo,
  }
};

export default physicalDebitCard;
